var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container view-page"},[(_vm.appMenus)?_c(_vm.navigateComponent,{tag:"component",attrs:{"userName":_vm.userName}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }